import styled from 'styled-components';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Delete } from 'ui/icons/action/Delete';

const Wrapper = styled.div`
  grid-area: right;
  align-self: start;
`;

type ClearContentButtonProps = {
  onClick: () => void;
};

export const ClearContentButton = ({ onClick }: ClearContentButtonProps) => (
  <Wrapper>
    <IconButton onClick={onClick} variant={BUTTON_VARIANTS.GHOST} data-test="clear-content-button">
      <Delete isColorInherited />
    </IconButton>
  </Wrapper>
);
